import React from 'react';

const Rectangle21Svg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M3 8v8h18V8H3zM2 7h20v10H2V7z" fillRule="nonzero" />
    </svg>
);

Rectangle21Svg.displayName = 'Rectangle21Svg';
export default Rectangle21Svg;
